module.exports = __webpack_public_path__ + "static/media/logo.46519a73.png";